<template>
  <div class="OriginEnterpriseApplyList" v-title data-title="水产圈子源头企业审核">
    <div class="pt5 text-left"><van-button size="small" class="btn-common" plain="" type="info"
              @click="back">返回</van-button></div>

    <div class="row align-items-center pr7">
      <div class="row align-items-center pt2">
        <div class="pl2 pr1">审核状态</div>
        <select placeholder="请选择审核状态" v-model="params.status">
          <option v-for="option in initInfo.status" :key="option.value" :value="option.value">
            {{option.text}}
          </option>
        </select>
      </div>
      <div class="row align-items-center pt2">
        <div class="pl2 pr1">支付状态</div>
        <select placeholder="请选择支付状态" v-model="params.payStatus">
          <option v-for="option in initInfo.payStatus" :key="option.value" :value="option.value">
            {{option.text}}
          </option>
        </select>
      </div>
      <div class="row align-items-center pt2">
        <div class="pl2 pr1">源头企业名称</div>
        <input class="keywords-input" v-model="params.storeName" placeholder="源头企业名称"/>
      </div>
      <div class="flex-1"></div>
      <div class="row">
        <div class="pt2 pl2">
          <van-button size="small" class="button"
                  @click="reset()">清除条件</van-button>
        </div>
        <div class="pt2 pl2">
          <van-button type="info" size="small" class="button"
                  @click="getData()">查 询</van-button>
        </div>
      </div>
    </div>
    <div class="row align-items-center pr7 pt5 pl3">
      <div class="font-bold flex-1 text-left">共{{(total||0)}}条审核信息</div>
    </div>
    <van-list
      v-model="loading"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      :finished="finished"
      :finished-text="records.length > 10 ? '没有更多了' :''"
      @load="loadMore"
    >
      <div class="pt5 text-left">
        <div class="row align-items-baseline line pl1 font-bold">
          <div v-for="col in columns" :key="col.dataIndex" :class="`${col.class} pr1 pt1 pb1`">{{ col.title }}</div>
        </div>
        <div class="row align-items-center line pl1"
          v-for="(item) in records"
          :key="item.id"
          >
          <div v-for="col in columns" :key="col.dataIndex" :class="`${col.class} pr1 pt1 pb1`">
            <template v-if="col.dataIndex === 'op'">
              <van-button v-for="op in col.operations" :key="op.code" size="mini" :type="op.type" @click="handleOpertion(op, item)">{{ op.text }}</van-button>
            </template>
            <template v-else>
              {{ item[col.dataIndex] }}
            </template>
          </div>
        </div>
      </div>
    </van-list>

    <van-popup v-model="detailShow">
      <div class="padding7 text-left image-preview">
        <div class="preview-title">【{{ detail.nickname || '未填写昵称' }}】申请加入【{{ detail.marketName || '未知源头企业'}}】的资料证明</div>
        <!-- <div class="row align-items-center"> -->
          <div
            :key="url" v-for="url in detail.paths">
            <van-image
              width="100%"
              fit="cover"
              :src="`${url.includes('http') ? '' : fileDomain}${url}`"
              style="{border: '1px solid red'}"
            >
              <template v-slot:loading>
                图片加载中<van-loading type="spinner" size="20" />
              </template>
            </van-image>
          <!-- </div> -->
        </div>
      </div>
    </van-popup>
    <van-dialog v-model="rejectReasonShow" title="不通过原因" @confirm="rejectStatus">
      <div class="padding7">
        <textarea v-model="rejectReason" class="w100p" placeholder="请输入不通过原因"></textarea>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  sendRequest, getOriginEnterpriseApplyList, getOriginEnterpriseApplyInit, originEnterpriseApprove, originEnterpriseReject,
} from '../../network/NetworkAccessor';
import storage from '../../uitls/cacheUtil';
import config from '../../config';

const STATUS = {
  AUTO_APPROVED: 0,
  UNVERIFIED: 1,
  REFUSED: 3,
  APPROVED: 2,
};

const statusName = {
  [STATUS.AUTO_APPROVED]: '自动审核通过',
  [STATUS.UNVERIFIED]: '待人工审核',
  [STATUS.REFUSED]: '人工审核不通过',
  [STATUS.APPROVED]: '人工审核通过',
};
export const SALE_TYPES = [
  {
    value: '1001',
    text: '出售',
  },
  {
    value: '1002',
    text: '求购',
  },
  {
    value: '1003',
    text: '其他',
  },
];
const defaultParams = {
  status: null,
  payStatus: null,
  storeName: null,
};
export default Vue.extend({
  name: 'OriginEnterpriseApplyList',
  components: {},
  data() {
    const statusOptions = Object.entries(statusName).map(([value, text]) => ({
      value,
      text,
    }));
    statusOptions.unshift({ value: '', text: '全部' });
    return {
      fileDomain: config.FILE_DOMAIN,
      STATUS,
      statusOptions,
      SALE_TYPES,
      loading: false,
      error: false,
      finished: false,
      size: 30,
      current: 0,
      total: 1,
      pages: 1,
      hasNext: true,
      records: [],

      detail: {},
      detailShow: false,
      rejectReasonShow: false,
      rejectId: '',
      rejectReason: '',
      params: { ...defaultParams },
      initInfo: {
        status: [],
        payStatus: [],
      },
      columns: [
        {
          dataIndex: 'enterpriseName',
          title: '源头企业',
          class: 'col-2',
        },
        // {
        //   dataIndex: 'enterpriseTelephone',
        //   title: '源头企业手机号',
        //   class: 'col-2',
        // },
        {
          dataIndex: 'nickname',
          title: '昵称',
          class: 'col-2',
        },
        {
          dataIndex: 'wechatNo',
          title: '微信号',
          class: 'col-2',
        },
        {
          dataIndex: 'phoneNumber',
          title: '用户手机号',
          class: 'col-3',
        },
        {
          dataIndex: 'payStatusName',
          title: '支付状态',
          class: 'col-2',
        },
        {
          dataIndex: 'statusName',
          title: '审核状态',
          class: 'col-2',
        },
        {
          dataIndex: 'createTime',
          title: '提交审核时间',
          class: 'col-4',
        },
        {
          dataIndex: 'rangeTime',
          title: '有效期间',
          class: 'col-4',
        },
        {
          dataIndex: 'op',
          title: '操作',
          class: 'col-3',
          operations: [
            {
              code: 'view',
              text: '编辑',
              type: 'info',
            },
            {
              code: 'approve',
              text: '通过',
              type: 'primary',
            },
            {
              code: 'reject',
              text: '拒绝',
              type: 'danger',
            },
          ],
        },
      ],
      editInfo: {},
    };
  },
  methods: {
    approve(item) {
      // if (!this.validValues()) {
      //   return;
      // }
      this.editInfo = { ...item };
      this.$dialog.confirm({
        title: '确定',
        message: '确定审核通过吗？',
      }).then(() => {
        sendRequest(originEnterpriseApprove, {
          id: this.editInfo.id,
        }).then((res) => {
          this.getData();
          this.$dialog.alert({
            message: '操作成功',
          });
        }).catch((e) => {
          console.log(e);
          this.$dialog.alert({
            message: `${e.message}`,
          });
        }).then(() => {
          this.$nextTick(() => {
            this.loading = false;
          });
        });
      });
    },
    reject(item = {}) {
      // if (!this.validValues()) {
      //   return;
      // }
      this.rejectReason = '';
      this.editInfo = {};
      this.$dialog.confirm({
        title: '确定',
        message: '确定不通过吗？',
      }).then(() => {
        this.rejectReasonShow = true;
        this.editInfo = { ...item };
      });
    },
    rejectStatus() {
      if (!this.rejectReason) {
        this.$dialog.alert({
          message: '请输入拒绝原因',
        });
        return;
      }
      sendRequest(originEnterpriseReject, {
        id: this.editInfo.id,
        rejectReason: this.rejectReason,
      }).then((res) => {
        this.getData();
        this.$dialog.alert({
          message: '操作成功',
        });
      }).catch((e) => {
        console.log(e);
        this.$dialog.alert({
          message: `${e.message}`,
        });
      }).then(() => {
        this.$nextTick(() => {
          this.loading = false;
        });
      });
    },
    reset() {
      this.params = { ...defaultParams };
    },
    handleOpertion(op, data) {
      // console.log('op:', op);
      if (op.code === 'view') {
        window.open(`/origin-enterprise/apply/edit/${data.id}`);
        return;
      }
      if (op.code === 'approve') {
        this.approve(data);
        return;
      }
      if (op.code === 'reject') {
        this.reject(data);
      }
    },
    viewInfopic(item) {
      // console.log('查看资料图片', item);
      this.editItem(item);
    },
    editItem(item = {}) {
      this.detail = { ...item, paths: (item.material.split(',') || []) };
      this.detailShow = true;
    },
    saveItem() {

    },
    getOriginEnterpriseApplyInit() {
      sendRequest(getOriginEnterpriseApplyInit).then((res) => {
        const { payStatus = [], status = [] } = res || {};
        payStatus.unshift({
          value: null,
          text: '全部',
        });
        status.unshift({
          value: null,
          text: '全部',
        });
        this.initInfo = {
          payStatus,
          status,
        };
      }).catch((e) => {
        console.log(e);
      }).then(() => {
        this.$nextTick(() => {
          this.loading = false;
        });
      });
    },
    exportData(e = {}) {
      this.$dialog.confirm({
        title: '确认',
        message: '确定立即下载人脉信息吗？',
      }).then(() => {
        const token = storage.local.get('token') || '';
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = `${config.DOWNLOAD_DOMAIN}/api/connections/report?token=${token}`;
        // console.log(link.href);
        // 获取文件名
        // download 属性定义了下载链接的地址而不是跳转路径
        link.setAttribute('download', '人脉圈子.xlsx');
        document.body.appendChild(link);
        link.click();
      }).catch(() => {
        // on cancel
      });
    },
    loadMore() {
      if (this.pages <= this.current) {
        return;
      }
      this.getData(this.current + 1);
    },
    getData(page = 1) {
      // console.log(this.loading);
      this.error = false;
      sendRequest(getOriginEnterpriseApplyList, {
        current: page,
        size: this.size,
        ...this.params,
      }).then((res) => {
        const {
          total = 1, records: list = [], pages = 1, hasNext = false,
        } = res;
        const records = (list || []).map(item => ({
          ...item,
          rangeTime: (item.approveTime && item.expirationTime) ? `${item.approveTime}~${item.expirationTime}` : '',
        }));
        // eslint-disable-next-line eqeqeq
        if (page == 1) {
          this.records = records || [];
        } else {
          this.records = this.records.concat(records || []);
        }
        this.total = total;
        this.pages = pages;
        this.hasNext = hasNext;
        this.current = page;
        if (!this.hasNext || (records || []).length < this.size || this.records.length >= this.total) {
          this.finished = true;
        } else {
          this.finished = false;
        }
      }).catch((e) => {
        console.log(e);
        this.$dialog.alert({
          message: `${e.message}`,
        });
        this.error = true;
      }).then(() => {
        this.$nextTick(() => {
          this.loading = false;
        });
      });
    },
    goDetail(e = {}) {
      storage.local.set('busername', e.username || '');
      if (e.id) {
        this.$router.push(`/user/edit/${e.type === 3 ? 'hzdw' : 'bjs'}/${e.id || ''}`);
      } else {
        this.$router.push('/user/home');
      }
    },
    goNotice(e = {}) {
      this.$router.push('/notice/info');
    },
    goData(url) {
      this.$router.push(url || '/data/info');
    },
    goSet(e = {}) {
      // storage.local.set('busername', e.username || '');
      this.$router.push(`/user/sync/rule/${e.id || ''}`);
    },
    back() {
      // this.$router.back();
      this.$router.push('/home');
    },
  },
  created() {
    this.getOriginEnterpriseApplyInit();
  },
});
</script>
<style scoped>
  .OriginEnterpriseApplyList {
    min-height: 100vh;
    background-color: #ffffff;
    font-size: 14px;
  }
  input, select {
    height: 26px;
    width: 110px;
    font-size: 14px;
    border: 1px solid #a7a9af;
    background-color: #ffffff;
    min-width: 100px;
    border-radius: 4px;
  }
  .keywords-input {
    width: 140px;
  }
  .date-select {
    width: 90px;
  }
  .button {
    min-width: 80px;
    height: 26px;
  }
  .image-preview {
    max-width: 90vw;
    width: 700px;
    position: relative;
  }
  .preview-title {
    /* position: absolute;
    left: 0;
    top: 0;
    width: 100%; */
    background-color: #ffffff;
    padding: 15px;
  }
</style>
